import { render, staticRenderFns } from "./VacanciesListDetailAddPage.vue?vue&type=template&id=df1e2c3c&scoped=true&"
import script from "./VacanciesListDetailAddPage.vue?vue&type=script&lang=js&"
export * from "./VacanciesListDetailAddPage.vue?vue&type=script&lang=js&"
import style0 from "./VacanciesListDetailAddPage.vue?vue&type=style&index=0&id=df1e2c3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df1e2c3c",
  null
  
)

/* custom blocks */
import block0 from "./VacanciesListDetailAddPage.vue?vue&type=custom&index=0&blockType=i18n&lang=yml&locale=ru"
if (typeof block0 === 'function') block0(component)
import block1 from "./VacanciesListDetailAddPage.vue?vue&type=custom&index=1&blockType=i18n&lang=yml&locale=en"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
